import {
  TutorialContentAlertBlock,
  TutorialContentContentBlock,
  TutorialContentSourceBlock,
  TutorialContentTopBlock,
} from '@/templates/Tutorial';

export type OrderedObject = {
  [T in KindMethodKeys]?: ChildMethod[];
};

export enum KindMethodKeys {
  ENUM = 'enum',
  MODULE = 'module',
  METHOD = 'method',
  CLASS = 'class',
  HOWTO = 'howto',
  INTERFACE = 'interface',
  NAMESPACE = 'namespace',
  PROTOCOL = 'protocol',
  CONSTANTS = 'constants',
  REF_FOLDER = 'ref_folder',
  FOLDER = 'folder',
  ROOT = 'root',
  TUTORIAL = 'tutorial',
  CHANGELOG = 'changelog',
  PROP = 'prop',
  MEMBER = 'member',
  EVENTS = 'events',
  CONSTRUCTOR = 'constructor',
  ERROR_LIST = 'error_list',
  TYPEDEF = 'typedef',
  FUNCTION = 'function',
  VAR = 'var',
  CONST = 'const',
  GETTER = 'getter',
  SETTER = 'setter',
  API_METHOD = 'api_method',
  API_STRUCT = 'api_struct',
  API_FIELD = 'api_field',
  OBJECT = 'object',
}

export interface ChildMethod {
  description: string | LangsOfSdk[keyof LangsOfSdk];
  fqdn: string;
  kind: KindMethodKeys[keyof KindMethodKeys];
  params: ChildParams[];
  returns: ChildReturns[];
  title: string | LangsOfSdk[keyof LangsOfSdk];
}

export interface MethodType {
  description: string;
  fqdn: string;
  kind: KindMethodKeys[keyof KindMethodKeys];
  children?: ChildMethod[];
  title?: string;
  attributes: MethodAttributes;
  content?: Array<
    | TutorialContentTopBlock
    | TutorialContentAlertBlock
    | TutorialContentContentBlock
    | TutorialContentSourceBlock
  >;
}

export interface MethodAttributes {
  beta: string;
  deprecated: string;
  hidden: string;
  see: string;
  platform?: { [k: string]: string };
  since: string;
}

export interface ChildParams {
  description: string;
  name: string;
  type: string;
}

export interface LangsOfSdk {
  http_api: HttpapiLangs;
  voxengine: VoxengineLangs;
  websdk: WebsdkLangs;
  androidsdk: AndroidsdkLangs;
  androidsdk3: Androidsdk3Langs;
  iossdk: IossdkLangs;
  reactnative: Reactnative;
}

export interface HttpapiLangs {
  nodejs?: string;
  php?: string;
  python?: string;
  go?: string;
  curl: string;
}

export interface VoxengineLangs {
  javascript: string;
}

export interface WebsdkLangs {
  javascript: string;
}

export interface Androidsdk3Langs {
  kotlin?: string;
}

export interface AndroidsdkLangs {
  java?: string;
  kotlin?: string;
}

export interface IossdkLangs {
  objc: string;
  swift?: string;
}

export interface Reactnative {
  javascript: string;
}

export interface ChildReturns {
  description: string | LangsOfSdk[keyof LangsOfSdk];
  type: string | LangsOfSdk[keyof LangsOfSdk];
}

export enum BadgesType {
  OPTIONAL = 'optional',
  DEPRECATED = 'deprecated',
  STATIC = 'static',
  BETA = 'beta',
  HIDDEN = 'hidden',
  WARNING = 'warning',
}
